import { Controller } from "@hotwired/stimulus";

interface SaveToggledDetail {
  status?: "saved" | "unsaved" | string;
  recordKey?: string;
}

export default class extends Controller {
  static targets = ["button"];
  static values = {
    active: {
      type: Boolean,
      default: false,
    },
    recordKey: String,
    on: String,
    off: String,
  };

  declare activeValue: boolean;
  declare recordKeyValue: string;
  declare hasRecordKeyValue: boolean;
  declare onValue: string;
  declare offValue: string;
  declare buttonTargets: Array<HTMLButtonElement>;
  private handleUpdate = this.update.bind(this);

  connect() {
    this.bindMethods();
  }

  disconnect() {
    this.unbindMethods();
  }

  bindMethods() {
    window.addEventListener("save:toggled", this.handleUpdate);
  }

  unbindMethods() {
    window.removeEventListener("save:toggled", this.handleUpdate);
  }

  update(event: Event) {
    const detail = (event as CustomEvent<SaveToggledDetail>).detail;

    if (!this.shouldHandle(detail)) return;

    this.activeValue = detail?.status === "saved";

    this.buttonTargets.forEach((target: HTMLButtonElement) => {
      this.updateButton(target);
      const button = this.getButtonText(target);
      if (button)
        button.textContent = this.activeValue ? this.onValue : this.offValue;
    });
  }

  shouldHandle(detail?: SaveToggledDetail) {
    if (detail?.recordKey) {
      return this.hasRecordKeyValue && this.recordKeyValue === detail.recordKey;
    }
    return false;
  }

  getButtonText(target: HTMLButtonElement) {
    return target.querySelector("span");
  }

  updateButton(el: HTMLButtonElement) {
    el.dataset.status = `${this.activeValue}`;
  }
}
